import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['editableDiv', 'hiddenInput']
  static values = {
    id: Number,
    placeholder: String
  }

  connect() {
    this.originalContent = this.editableDivTarget.innerHTML.trim()
  }

  handleClick() {
    const value = this.editableDivTarget.innerHTML.trim()

    if (value === this.placeholderValue) {
      this.editableDivTarget.innerHTML = ''
      this.editableDivTarget.focus()
    }
  }

  handleBlur() {
    this.handleSubmitOrReset()
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.handleSubmitOrReset()
      this.editableDivTarget.blur()
    } else if (event.key === 'Escape') {
      this.editableDivTarget.innerHTML = this.originalContent
      this.editableDivTarget.blur()
    }
  }

  handleSubmitOrReset() {
    const currentContent = this.editableDivTarget.innerHTML.trim()

    if (currentContent !== this.originalContent && currentContent !== '') {
      this.hiddenInputTarget.value = currentContent
      this.element.requestSubmit()
    } else {
      this.editableDivTarget.innerHTML = this.originalContent
    }
  }
}
